import { useAtomValue, useStore } from "jotai";
import React from "react";
import { agentChatSidebarAtom } from "services/atoms";
import { dockBusyAtom, dockedConversationAtom, handBackDockedConversation } from "../hooks/useOwnConversation";
import { QuincyShell } from "./QuincyShell";

// Statically imported by the guard, so it must not pull in the chat's own dependencies (ai, streamdown).
const AiChatPanel = React.lazy(() => import("./AiChatPanel"));

/** The aside's same-width placeholder, so the page reflows beside the docked panel at desktop widths. */
export const AiChatDock = ({ onOpenShell }: { onOpenShell?: () => void }) => {
  const store = useStore();
  // The panel reads the pointer once, so it waits until the takeover's hand-back (at commit, or here after a closed tab).
  const subscribe = (onChange: () => void) => store.sub(dockedConversationAtom, onChange);
  const saved = React.useSyncExternalStore(subscribe, () => store.get(dockedConversationAtom));
  React.useLayoutEffect(() => handBackDockedConversation(store), [store]);
  const open = useAtomValue(agentChatSidebarAtom);
  const busy = useAtomValue(dockBusyAtom);
  // Loaded on first open, then kept mounted.
  const [hasOpened, setHasOpened] = React.useState(open);
  if (open && !hasOpened) setHasOpened(true);

  const panel = hasOpened && (!saved || busy) && (
    <React.Suspense fallback={null}>
      <AiChatPanel variant={onOpenShell ? "shell" : "dock"} />
    </React.Suspense>
  );

  return (
    <QuincyShell open={open} onOpen={onOpenShell}>
      {panel}
    </QuincyShell>
  );
};
